import { Flex, Heading, Box, Text } from "@chakra-ui/react"
import React, { useEffect, useState } from "react"
import { toast } from "react-toastify"
require("isomorphic-fetch")
import { navigate } from "gatsby-link"
import { getApiUrl, getUserId, getUserVerified } from "../../utils/loginInfo"
import { AuthButton } from "../form/AuthHeader"
import { colors } from "../colors/colors"
import { usePurchasingCTAs } from "../form/usePurchasingCTAs"

export function ChoosePlan({ header, subheader }) {
	const {
		titleBg,
		titleColor,
		type,
		products,
		appConfirmation,
	} = usePurchasingCTAs()
	const [utmCampaignId, setUtmCampaignId] = useState(``)
	const [subscriptions, setSubscriptions] = useState([])
	const [plan, setPlan] = useState()
	const [planInterval, setPlanInterval] = useState("year")
	useEffect(() => {
		if (typeof window !== "undefined") {
			if (window.localStorage.getItem("utm:campaign:payments")) {
				setUtmCampaignId(
					window.localStorage.getItem("utm:campaign:payments")
				)
			}

			fetch(
				`${getApiUrl()}/subscription/products${products?.queryParam}`,
				{
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"X-M-P": "3",
					},
				}
			)
				.then(res => {
					if (res.status === 200) {
						return res.json()
					}
				})
				.then(response => {
					if (response) {
						setSubscriptions(response)

						setPlan(response[0]?.prices[0])
					}
				})
		}
	}, [])

	const checkoutPlan = () => {
		const userId = getUserId()
		if (plan) {
			fetch(`${getApiUrl()}/subscription/checkoutsession`, {
				method: "POST",
				body: JSON.stringify({
					priceId: plan?.id,
					successUrl: `${window.location.origin}${appConfirmation?.link}?tag=${utmCampaignId}`,
					cancelUrl: `${window.location.origin}${products?.link}`,
					userId,
				}),
				headers: {
					"Content-Type": "application/json",
					"X-M-P": "3",
				},
			})
				.then(res => {
					return res.json()
				})
				.then(response => {
					if (response?.url) {
						if (typeof window !== `undefined`) {
							window.location.assign(response?.url)
							return
						}
					}

					const isVerified = getUserVerified()

					if (response?.type === `https://mojo.sport/errors/1012`) {
						if (isVerified) {
							return toast.error(response?.title)
						} else {
							toast.error(
								`${response?.title}. Your account's email has not been verified`,
								{
									hideProgressBar: true,
								}
							)
							setTimeout(() => {
								return navigate("/email-verification")
							}, 2000)
						}
					}
				})
		} else {
			console.log("Please choose a plan")
		}
	}
	const prices = subscriptions[0]?.prices?.sort((a, b) =>
		a.recurringInterval < b.recurringInterval ? 1 : -1
	)

	return (
		<Box maxW={{ base: `100%`, lg: "335px" }}>
			<Box mb="42px">
				<Heading
					display={{
						base: `block`,
						md: type === `BASE` ? `none` : `block`,
					}}
					textTransform="uppercase"
					textAlign={{ base: `center`, md: "left" }}
					fontSize={{ base: `28px`, md: "30px" }}
					lineHeight="32px"
					fontWeight="600"
				>
					<Box as="span" bg={titleBg} color={titleColor}>
						{header || products?.title}
					</Box>
				</Heading>
				{subheader && (
					<Text
						display={{
							base: `block`,
							md: type === `BASE` ? `none` : `block`,
						}}
						fontSize="16px"
						lineHeight="24px"
						mt="20px"
						textAlign={{ base: `left`, md: "left" }}
					>
						{subheader}
					</Text>
				)}

				<Text
					display={type !== `BASE` ? `none` : `block`}
					fontSize="18px"
					mt="20px"
					textAlign={{ base: `center`, md: "left" }}
				>
					Choose your plan:
				</Text>
			</Box>
			{prices?.map(
				({
					id,
					price,
					displayName,
					recurringInterval,
					recurringIntervalCount,
					isBestValue,
					savePercentageString,
				}) => {
					return (
						<Box
							cursor="pointer"
							alignSelf="center"
							color={
								plan === id
									? products?.textColor || colors.purple
									: "black"
							}
							fontWeight={plan === id && 600}
							height="120px"
							margin="20px 0px"
							padding="14px 20px"
							onClick={() => {
								setPlan({
									id,
									price,
									recurringInterval,
									recurringIntervalCount,
								})
								setPlanInterval(
									recurringInterval === "year"
										? "year"
										: "month"
								)
							}}
							bg="white"
							border={`2px solid ${
								plan?.id === id
									? products?.outline || colors.purple
									: "#C7C7CC"
							}`}
							borderRadius="10px"
							position="relative"
						>
							{isBestValue && (
								<Box
									position="absolute"
									top="-11px"
									bg={colors.purple}
									borderTopRadius="2px"
									borderBottomRadius="2px"
									borderLeftRadius="2px"
									borderRightRadius="2px"
									padding="2px 6px"
								>
									<Text
										textAlign="right"
										color="white"
										textTransform="uppercase"
										fontSize="11px"
										mb="0"
									>
										BEST VALUE
									</Text>
								</Box>
							)}

							<Flex justifyContent="space-between">
								{products?.ProductsImageComponent && (
									<Box>
										<products.ProductsImageComponent />
									</Box>
								)}

								<Box>
									<Text mb="10px">{displayName}</Text>

									<Text mb="10px">
										{`$${price / 100} / ${
											recurringIntervalCount > 1
												? ` ${recurringIntervalCount} `
												: ``
										}${recurringInterval}${
											recurringIntervalCount > 1
												? `s`
												: ``
										}`}
									</Text>
									{products?.includesTrial && (
										<Text fontSize="12px">
											Includes 7-day free trial
										</Text>
									)}
								</Box>

								{savePercentageString && (
									<Box>
										<Box
											bg={colors.purple}
											borderTopRadius="2px"
											borderBottomRadius="2px"
											borderLeftRadius="2px"
											borderRightRadius="2px"
											padding="2px 6px"
										>
											<Text
												textAlign="right"
												color="white"
												textTransform="uppercase"
												fontSize="13px"
												mb="0"
											>
												{savePercentageString}
											</Text>
										</Box>
									</Box>
								)}
							</Flex>
						</Box>
					)
				}
			)}
			<Box textAlign="center" fontSize="14px" margin="20px 0px">
				{products?.includesTrial && (
					<Text>
						Includes a 7 day free trial, then{" "}
						{plan &&
							`$${plan?.price / 100} / ${
								plan?.recurringIntervalCount > 1
									? ` ${plan?.recurringIntervalCount} `
									: ``
							}${plan?.recurringInterval}${
								plan?.recurringIntervalCount > 1 ? `s` : ``
							}`}
						.
					</Text>
				)}

				<Text>Cancel anytime.</Text>
			</Box>
			<AuthButton
				id={utmCampaignId}
				label={products?.buttonText}
				onClick={() => checkoutPlan()}
				type="button"
			/>
		</Box>
	)
}
